/**
 * Stacking-order constants (TV1-2357).
 *
 * Mantine ships a z-index scale and the app has been ignoring it, so overlays
 * were picking numbers by feel. The result: list loading overlays sat at 300,
 * Mantine's POPOVER level, which is above its MODAL level of 200. Open any modal
 * over a list that was still loading — or that started loading underneath, which
 * a signal-driven refetch does on its own — and a blurred sheet dropped over the
 * modal the user was reading.
 *
 * Mantine's scale, for reference:
 *
 *   app      100   ← page chrome
 *   modal    200   ← Modal, Drawer
 *   popover  300   ← Popover, Menu, Select dropdowns, Tooltip
 *   overlay  400   ← LoadingOverlay's own default
 *   max     9999
 *
 * The rule this file exists to make hard to get wrong:
 *
 *   A loading overlay must sit below every layer that can be stacked ON TOP of
 *   the thing it covers.
 *
 * A list's overlay covers the list. Modals, menus and dropdowns all open above
 * the list, so the overlay has to be below all of them — hence `app`. An overlay
 * INSIDE a modal is a different case: it lives in the modal's own stacking
 * context and covers only the modal's content, so it does not belong here.
 */
export const zIndex = {
  /**
   * Loading overlays over page-level content: lists, tables, mobile card
   * columns, tab bodies.
   *
   * Deliberately BELOW `modal` (200). Anything covering a list must not outrank
   * a modal opened over that list.
   */
  contentLoadingOverlay: 100
} as const;
